<template>
  <div class="col-lg-12">
    <div v-if="$store.state.hasDiscount" key="NOTICES" class="row">
      <div class="col-sm-12">
        <div data-notify="container" class="col-md-12 alert alert-warning alert-with-icon ">
          <span data-notify="icon" class="fa fa-exclamation"></span>
          <span data-notify="message">SPECIAL OFFER: Complete your application in October and save 10% off the Qualification Check fee. Offer ends 5th of November.</span>
        </div>
      </div>
    </div>
    <!--
    <div v-if="public" key="NOTICES" class="row">
      <div class="col-sm-12">
        <div data-notify="container" class="col-md-12 alert alert-warning alert-with-icon ">
          <span data-notify="icon" class="fa fa-exclamation"></span>
          <span data-notify="message">NOTICE: Unregistered public sharing of results has now been retired as of Feb 3rd, 2025. Please request these results are shared privately to you instead.</span>
        </div>
      </div>
    </div>
    -->
      <div class="card">
        <div class="card-header">
          <div class="card-title">
            <div class="document-card-title">
              <div class="row xstarter">
                <span class="col-xs-1"><i class="fa fa-4x qc2-wal"/></span>
                <div v-if="!public" class="col-xs-10" style="line-height: 1; font-size: 1.5em"></div>
                <div v-else-if="history.length > 0" class="col-xs-7" style="font-size: 1.5em">{{history[0].fields.firstname}} {{history[0].fields.surname}}</div>
                <span v-if="!public && history.length > 0 && !this.$store.state.sharingDisabled" class="col-xs-1"><button @click="sharingActiveName = 'open'; $scrollTo('#sharingCenter')" class="btn btn-fill pull-right">Share</button></span>
                  
              </div>
            </div>
          </div>
        </div>
        <div class="card-content row">
          <div class="col-md-10 col-md-offset-1" 
            v-qcloading="history.length < 1" 
            element-loading-text1="Your Verification Wallet is currently empty!" 
            element-loading-text2="Start building up your wallet by adding a new verification." 
            element-loading-button-text="Add a new Verification"
            element-loading-button-icon="fa fa-plus"
            :element-loading-button-url="$store.state.isApplicant && $store.state.openApplications > 0 ? '/applications/open' : '/verification/new'"
            element-loading-background="rgba(40,70,90, 0.7">
              <wallet-pocket v-if="(!public || eduHistory.length > 0) && (!this.$store.state.sharingDisabled || eduHistory.length > 0)" title="Education History" icon="qc2-edu" newUrl="/verification/new?nedu=1" :verifications="eduHistory" :builtVerifications="builtHistory" :public="public" :startOpen="(hscHistory.length == 0 && empHistory.length ==0  && pliHistory.length ==0 && pceHistory.length ==0 && idcHistory.length ==0)"/>

              <wallet-pocket v-if="(!public || hscHistory.length > 0) && (!this.$store.state.sharingDisabled || hscHistory.length > 0)" title="High School History" icon="qc2-bul" newUrl="/verification/new?nhsc=1" :verifications="hscHistory" :builtVerifications="builtHistory" :public="public" :startOpen="(eduHistory.length == 0 && empHistory.length ==0  && pliHistory.length ==0 && pceHistory.length ==0 && idcHistory.length ==0)"/>
              
              <wallet-pocket v-if="(!public || empHistory.length > 0) && (!this.$store.state.sharingDisabled || empHistory.length > 0)" title="Employment History" icon="qc2-emp" newUrl="/verification/new?nemp=1" :verifications="empHistory" :builtVerifications="builtHistory" :public="public" :startOpen="(hscHistory.length == 0 && eduHistory.length ==0  && pliHistory.length ==0 && pceHistory.length ==0 && idcHistory.length ==0)"/>
              
              <wallet-pocket v-if="(!public || pliHistory.length > 0) && (!this.$store.state.sharingDisabled || pliHistory.length > 0)" title="Professional Licences" icon="qc2-pli" newUrl="/verification/new?npli=1" :verifications="pliHistory" :builtVerifications="builtHistory" :public="public" :startOpen="(hscHistory.length == 0 && empHistory.length ==0  && eduHistory.length ==0 && pceHistory.length ==0 && idcHistory.length ==0)"/>
              
              <wallet-pocket v-if="(!public || pceHistory.length > 0) && (!this.$store.state.sharingDisabled || pceHistory.length > 0)" title="Professional Certificates" icon="qc2-pce" newUrl="/verification/new?npce=1" :verifications="pceHistory" :builtVerifications="builtHistory" :public="public" :startOpen="(hscHistory.length == 0 && empHistory.length ==0  && pliHistory.length ==0 && eduHistory.length ==0 && idcHistory.length ==0)"/>

              <wallet-pocket v-if="(!public || idcHistory.length > 0) && (!this.$store.state.sharingDisabled || idcHistory.length > 0)" title="Identity" icon="fa fa-id-badge" newUrl="/verification/new?idce=1" :verifications="idcHistory" :builtVerifications="builtHistory" :public="public" :startOpen="(hscHistory.length == 0 && empHistory.length ==0  && pliHistory.length ==0 && eduHistory.length ==0 && pceHistory.length ==0)" :allowAdd="$store.state.idCount < 1"/>
          </div>
        </div>
        <br/>
        <br/>
        <br/> 
      </div>


      <div id="sharingCenter" v-if="!public && history.length > 0" class="card whitecollapse">
        <qc-collapse accordion v-model="sharingActiveName" v-if="!this.$store.state.sharingDisabled">
          <qc-collapse-item name="open">
            <div class="nowrap" slot="title" style="width: 100%">
              <div class="row xstarter">
                <span class="col-xs-1" style="display:flex"><i class="fa fa-3x fa-share-alt"/></span>
                <div class="col-xs-11">
                  Sharing Center
                  <span class="pull-right">{{sharingActiveName == 'open' ? 'Close' : 'Open'}}</span>
                </div>
              </div>
            </div>
            <sharing-center :wallet="true" />
            </qc-collapse-item>
          </qc-collapse>
          <div v-if="this.$store.state.sharingDisabled && this.$store.state.isApplicant" style="padding: 15px">
            <p><b>Applications</b></p>
            <p>Your verification(s) form part of an application to a third party organisation. All staff registered with Qualification Check at that orangisation will have access to your verification(s) as part of your application to them. A list of your applications is shown below.</p>     
            <el-table class="table table-striped table-no-bordered table-hover"
                :data="applications"
                size="mini"
                style="width: 100%">
                <span slot="empty">No applications made.</span>
                <el-table-column label="Application Date"><template slot-scope="props">{{ formatDate(props.row.created) }}</template></el-table-column>
                <el-table-column label="Organisation"><template slot-scope="props">{{ props.row.owner.name }}</template></el-table-column>
                <el-table-column label="Verifications included"><template slot-scope="props">{{props.row.verificationCount}}</template></el-table-column>
              </el-table>
              <p>Please note any listed applications are closed. If you need to add any additional verifications, please contact <a href="mailto:applicantsupport@qualificationcheck.com">applicantsupport@qualificationcheck.com</a></p>     
            
          </div>
        </div>
    </div>
</template>
<script>  
  import QCCollapse from 'src/components/QCCollapse'
  import QCCollapseItem from 'src/components/QCCollapseItem'
  import Pocket from 'src/views/Verifications/wallet/Pocket'
  import SharingCenter from 'src/views/Verifications/components/SharingCenter'
  import ModalPending from 'src/components/ModalPlugin/ModalPending'
  import { Loading } from 'element-ui';
  import moment from 'moment'

  export default {
    name: "verification-wallet",
    components: {
      'wallet-pocket': Pocket,
      'qc-collapse': QCCollapse,
      'qc-collapse-item': QCCollapseItem,
      'sharing-center': SharingCenter,
    },
    props: {
      public: {type: Boolean, default : false},
      initHistory: {type: Array, default: null}
    },
    data () {
      return {
        history: [],
        builtHistory: [],
        sharingActiveName: '',
        publicShares: [],
        privateShares: []
      }
    },
    mounted() {
      if(this.$store.state.sharingDisabled) {
        this.$api.getApplicationHistory({size:1000}) 
            .then(response => { this.applications = response.data.content })
            .catch(error => { console.log(error) })
      }
      if(this.initHistory) {
        this.buildInitHistory(this.initHistory)
      } else {
        this.getHistory()
      }
    },
    activated () {
      if(this.initHistory) {
        this.buildInitHistory(this.initHistory)
      } else {
        this.getHistory()
      }
    },
    computed: {
      eduHistory() {
        return this.history.filter(v => {
          return v.type == 'UNI'
        })
      },
      empHistory() {
        return this.history.filter(v => {
          return v.type == 'EMPLOYMENT'
        })
      },
      hscHistory() {
        return this.history.filter(v => {
          return v.type == 'HIGH_SCHOOL'
        })
      },
      pliHistory() {
        return this.history.filter(v => {
          return v.type == 'PROF_LIC'
        })
      },
      pceHistory() {
        return this.history.filter(v => {
          return v.type == 'PROF_CERT'
        })
      },
      idcHistory() {
        return this.history.filter(v => {
          return v.type == 'IDENTITY'
        })
      }
    },
    methods: {
      formatDate(date) {
        var m = moment(date)
        return m.format('DD MMM YYYY')
      },
      pendingModal() {
        let institutesList = this.$store.state.pendingInstitutesArray
        this.$modal.show(ModalPending,
          {
            title: "Pending Verifications",
            message1: `You currently have pending verifications at ${institutesList}.`,
            message: `"My verification is still pending, what do I do?"`,
            message2: "There is no need to panic, Qualification Check is here to help. Qualification Check understands that applications are urgent and we make every effort to accommodate clients’ needs and expedite processes. Continue to check your online platform for updates on your verifications every 48 hours to track its progress. Some institutions may take longer than others, but rest assured that Qualification Check is working hard to complete your verification.",
            actionText1: "I Understand",
            action1: () => 
              {
                this.$store.state.checkPending = false;
                this.$store.state.loginDialogBox = false;
                this.$modal.close()
              },
            })
          },
      buildInitHistory(initHistory) {
        var loading = Loading.service({
          spinner: 'qc-spinner',
          text: 'Loading verifications...'
        })
        this.history = initHistory
        var ps = []
        for(var i = 0; i < this.history.length; i++) {
          ps.push(this.buildVerification(this.history[i]))
        }
        Promise.all(ps).then(values => {
          this.builtHistory = values
          loading.close()
        })
        .catch(error => {
          loading.close()
        })
      },
      getHistory() {
        var loading = Loading.service({
          spinner: 'qc-spinner',
          text: 'Loading verifications...'
        })
        this.history = []
        this.builtHistory = []
        let historyRequest = {
          page: 0,
          size: 1000
        }
        this.$api.getVerificationHistoryLonger(historyRequest, false)
          .then(response => {
            this.history = response.data.content
            let pendingArray = [];
            for (let i = 0; i < this.history.length; i++) {
              if (this.history[i].result == "PENDING") {
                pendingArray.push(' ' + this.history[i].instituteName)
              }
              this.$store.state.pendingInstitutesArray = pendingArray;
              if (this.$store.state.pendingInstitutesArray < 0) {
                this.$store.state.loginDialogBox = true;
              }
            }
            var ps = []
            for (var i = 0; i < this.history.length; i++) {
              ps.push(this.buildVerification(this.history[i]))
            }
            Promise.all(ps).then(values => {
              this.builtHistory = values
              if (this.$store.state.checkPending == true && this.$store.state.pendingInstitutesArray.length != 0) {
                this.pendingModal()
              }
              loading.close()
            })
            .catch(error => {
              loading.close()
            })
        })
      },
      buildVerification(verification) {
        return new Promise((resolve, reject) => {
          this.$service.buildInstitute(verification.instituteId, verification)
            .then(response => {
              var builtVerification = this.$service.buildVerification(verification)
              builtVerification.institute = response
              resolve(builtVerification)
            })
            .catch(error => {
              console.log(error)
              reject("Failed to build verification result")
            })
        })
      }
    }
  }
</script>
<style>

</style>
